module.exports = __webpack_public_path__ + "static/media/Hull colour - pure white RAL 9010 & pastel blue RAL 5024 & 3 x  waterlines.598b19d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hullColors/Hull colour - pure white RAL 9010 & pastel blue RAL 5024 & 3 x  waterlines.jpg
// module id = 118
// module chunks = 0